export default __webpack_public_path__ + "static/media/no_cover.5f6aa998.png";